import clsx from 'clsx';
import { SettingsOptions } from 'core/config/settings-options';
import { useAuthState } from 'core/providers/AuthProvider';
import { Link, Outlet, useLocation } from 'react-router-dom';

const SettingsLayout = () => {
  const { userRoles } = useAuthState();
  const location = useLocation();

  const isActive = (route: string) => {
    return location.pathname.startsWith(`/settings/${route}`);
  };

  return (
    <>
      <div className='basis-[70px] grow-0 flex-shrink-0 border-b flex items-center overflow-x-auto space-x-4 mt-2'>
        {SettingsOptions.filter((item) => item.roles.some((role) => userRoles?.includes(role))).map((item) => (
          <Link key={item.route} to={item.route}>
            <div
              className={clsx(
                'button-xs rounded-md px-3 py-1.5 transition ease-in-out whitespace-nowrap',
                isActive(item.route) ? 'text-white' : `hover:bg-gray-100 hover:text-gray-800 text-gray-800`,
              )}
              style={{
                backgroundColor: isActive(item.route) ? '#007287' : '',
              }}
            >
              <p>{item.label}</p>
            </div>
          </Link>
        ))}
      </div>
      <Outlet />
    </>
  );
};

export default SettingsLayout;
